import type { DetailsProps, SummaryProps } from './types';

import { Body } from 'components/text';
import Button from 'components/Button/BaseButton';

import styles from './Summary.module.scss';
import CustomCardSummary from './custom-card-summary';
import { useRouter } from 'next/router';

const Summary: React.FC<SummaryProps> = ({
  sender,
  receiver,
  message,
  sendDate,
  amount,
  customGiftCardId,
}) => {
  return (
    <div className={styles.container}>
      <CustomCardSummary customGiftCardId={customGiftCardId} />

      <div className={styles.detailsContainer}>
        <div className={styles.total}>
          <Body weight="demiBold">Total</Body>
          <Body weight="demiBold">{amount}</Body>
        </div>
        <Details title="Sender" value={`${sender.name} - ${sender.email}`} />
        <Details
          title="Recipient"
          value={
            receiver?.name
              ? `${receiver.name} - ${receiver.email}`
              : receiver?.email || ''
          }
        />
        <Details title="Send date" value={sendDate} />
        <Details title="Your message" value={message} />

        <EditButton />
      </div>
    </div>
  );
};

const Details: React.FC<DetailsProps> = ({ title, value }) => {
  if (!value) {
    return null;
  }

  return (
    <div className={styles.details}>
      <Body weight="demiBold">{title}</Body>
      <Body color="grey-dark">{value}</Body>
    </div>
  );
};

const EditButton: React.FC = () => {
  const router = useRouter();

  const handleClick = () => {
    router.back();
  };

  return (
    <Button type="button" onClick={handleClick} className={styles.editButton}>
      Edit
    </Button>
  );
};

export default Summary;
